import { FileTreeType } from "@/zustand/fileTreeType";
import { create } from "zustand";

export interface WorkspaceStore {
  defaultSelections: { [workspaceId: string]: QuerySelection };
  setDefaultSelection: (workspaceId: string, selection: QuerySelection) => void;
}

export type QuerySelection = FileTreeType | undefined;

export const useWorkspaceStore = create<WorkspaceStore>((set) => ({
  // Object mapping workspace IDs to their default selections
  defaultSelections: {},

  // Function to update the default selection for a given workspace
  setDefaultSelection: (workspaceId: string, selection: QuerySelection) => {
    set((state) => ({
      defaultSelections: {
        ...state.defaultSelections,
        [workspaceId]: selection,
      },
    }));
    ``;
  },
}));
